import { fmt } from '../api.ts';

export interface SplitSide { label: string; boxes: number; run: number }

export function moveSides(jobNumber: string, ordered: number, run: number, moved: number): SplitSide[] {
  const partBoxes = moved - Math.round(((run - ordered) * moved) / run);
  return [
    { label: jobNumber, boxes: ordered - partBoxes, run: run - moved },
    { label: 'New part', boxes: partBoxes, run: moved },
  ];
}

export default function SplitTable({ sides, ups }: { sides: SplitSide[]; ups: number | null | undefined }) {
  const bySheet = !!ups && ups > 0;
  const rows = sides.map((s) => {
    const size = bySheet ? Math.ceil(s.run / ups!) : s.run;
    return { ...s, size, spare: bySheet ? size - Math.ceil(s.boxes / ups!) : s.run - s.boxes };
  });
  const total = rows.reduce((t, r) => ({ boxes: t.boxes + r.boxes, size: t.size + r.size, spare: t.spare + r.spare }),
    { boxes: 0, size: 0, spare: 0 });

  return (
    <table className="split-table">
      <thead>
        <tr><th /><th className="num">Boxes</th><th className="num">{bySheet ? 'Sheets' : 'Run'}</th><th className="num">Spare</th></tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.label}>
            <td>{r.label}</td>
            <td className="num">{fmt(r.boxes)}</td>
            <td className="num">{fmt(r.size)}</td>
            <td className="num">{fmt(r.spare)}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td>Total</td>
          <td className="num">{fmt(total.boxes)}</td>
          <td className="num">{fmt(total.size)}</td>
          <td className="num">{fmt(total.spare)}</td>
        </tr>
      </tfoot>
    </table>
  );
}
